export function DealBenefits() {
  const benefits = [
    {
      icon: 'ri-eye-line',
      title: 'Maximum Exposure',
      description: 'Your deals appear on our homepage, deals page, and in our weekly newsletter reaching 50,000+ local residents.'
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Track Performance',
      description: 'Real-time analytics dashboard showing views, clicks, and redemptions with unique coupon codes for each deal.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Flexible Pricing',
      description: 'Choose between flat monthly rates or commission-based pricing. Only pay when customers redeem your deals.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Easy Management',
      description: 'Update, pause, or extend your deals anytime through your business dashboard. No long-term contracts required.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile Optimized',
      description: 'Your deals look perfect on all devices. Customers can save, share, and redeem directly from their phones.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Dedicated Support',
      description: 'Our team helps optimize your deals for maximum engagement and provides monthly performance reports.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Advertise Your Deals on Roseville.com?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Join hundreds of local businesses using our platform to attract new customers and increase sales through targeted deal promotions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}